import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { acknowledgeTerminalGameSession } from '../utils/active-game-context';
import { devbackendUrl } from '../utils/constants';
import { AuthUtils } from '../utils/helper_functions';

const labelForReason = (reason: string) => {
  const labels: Record<string, string> = {
    all_humans_disconnected: 'The game ended because everyone disconnected.',
    all_humans_left: 'The game ended because all players left.',
    connection_deadline_exceeded: 'The game was cancelled because not everyone connected in time.',
    game_deadline_exceeded: 'The game expired and was safely closed.',
    host_cancelled: 'The host cancelled this game.',
    host_disconnected: 'The lobby closed after the host disconnected.',
    runtime_missing: 'The previous game could not be recovered and was safely closed.',
    server_restart: 'The previous game ended during a server restart.',
  };
  return labels[reason] || 'The previous game session has ended.';
};

const SessionEndNotice: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const reason = params.get('sessionEnded');
  const endedSessionId = params.get('endedSessionId');
  if (!reason) return null;

  const dismiss = () => {
    if (endedSessionId) {
      sessionStorage.setItem('dismissedGameSessionTerminalId', endedSessionId);
      const token = AuthUtils.getAuthToken();
      if (token) {
        void acknowledgeTerminalGameSession(
          devbackendUrl,
          token,
          Number(endedSessionId),
        ).catch(() => {
          // Keep the per-tab dismissal. A later active-session lookup can
          // surface the notice again if the durable acknowledgement failed.
        });
      }
    }
    params.delete('sessionEnded');
    params.delete('endedSessionId');
    navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
  };

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        zIndex: 99999,
        top: 14,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        maxWidth: 'calc(100vw - 28px)',
        padding: '11px 14px',
        borderRadius: 12,
        color: '#fff',
        background: 'rgba(38, 28, 12, .96)',
        border: '1px solid rgba(255, 193, 70, .7)',
      }}
    >
      <span>{labelForReason(reason)}</span>
      <button type="button" onClick={dismiss} aria-label="Dismiss game notice">×</button>
    </div>
  );
};

export default SessionEndNotice;
